import { NgModule } from '@angular/core'
import { ThemeService } from './theme.service'

export { ThemeService } from './theme.service'

@NgModule({
  imports: [],
  declarations: [],
  exports: [],
  providers: [ThemeService],
})
export class ThemeServiceModule {}
